import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";

export interface GTMEvent {
  event: string;
  beventname?: string;
  screen_name: string;
  journey_step?: string;
  action?: string;
  [key: string]: any;
}

export const pushToDataLayer = (eventData: GTMEvent) => {
  if (typeof window !== "undefined") {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    const { event, ...rest } = eventData;
    const seg = (window.location.pathname || "").split("/").filter(Boolean)[0];
    const reserved = ["register-link", "login", "select-event", "no-access"];
    const eventId =
      seg && !reserved.includes(seg) && /^\d+$/.test(seg) ? seg : undefined;
    const eventName = eventId
      ? JSON.parse(
          localStorage.getItem(LOCAL_STORAGE_KEYS.eventNamePerEventId) || "{}",
        )?.[eventId as unknown as number]
      : undefined;

    // @ts-ignore
    window.gtag("event", event, {
      ...rest,
      beventname: eventName,
    });
  }
};
